<template>
  <div class="smShopOrder">
    <div class="header x-flex x-row-between x-m-b-7">
      <div class="x-flex x-m-r-15">
        <el-date-picker size="medium" v-model="cancelDataTime" type="daterange" align="right" unlink-panels
        :default-time="['00:00:00', '23:59:59']"
          value-format='yyyy-MM-dd HH:mm:ss' format='yyyy-MM-dd HH:mm:ss' range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" :picker-options="pickerOptions" style="width: 380px" @change="nowPage=1;init()">
        </el-date-picker>
        <div class="x-p-l-20">
          <el-input placeholder="商品,商户,服务商,推荐人" v-model="merInputVal" size="medium" style="width: 310px"
            class="x-m-r-12 x-flex-1">
            <el-button size="medium" slot="append" @click="nowPage=1;init()">搜索</el-button>

          </el-input>
        </div>
        <el-checkbox v-model="checked">模糊</el-checkbox>
        <!-- <div class=" x-flex x-lh-28 x-p-l-40">
          <span class='x-p-r-10 x-w80'>
            支付状态：
          </span>
          <el-radio v-model="pay_state" label="">全部</el-radio>
          <el-radio v-model="pay_state" label="待付款">待付款</el-radio>
          <el-radio v-model="pay_state" label="已付款">已付款</el-radio>
        </div> -->
        <div class=" x-flex x-p-l-20 x-p-t-2">
          <div class=" x-flex x-lh-28 ">
            <span class='x-p-r-10 x-w80'>
              交易状态：
            </span>
            <el-radio class="x-m-r-10" v-model="order_state" label="">全部</el-radio>
            <el-radio class="x-m-r-10" v-model="order_state" label="待付款">待付款</el-radio>
            <el-radio class="x-m-r-10" v-model="order_state" label="待发货">待发货</el-radio>
            <el-radio class="x-m-r-10" v-model="order_state" label="已发货">已发货</el-radio>
            <el-radio class="x-m-r-10" v-model="order_state" label="已完成">已完成</el-radio>
          </div>
        </div>
      </div>
    </div>
    <el-card style="position: relative">
      <div style="height: calc(100vh - 198px)">
        <vxe-table border resizable highlight-hover-row height="100%" :data="tableData" align="center">
          <vxe-column field="RC" title="序号" width="50" fixed="left"></vxe-column>
          <vxe-column :field="item.sortType" :title="item.title" :width="item.width" v-for="(item,index) in tableJson"
            :key="index">
            <template #header>
              <div class="x-flex x-row-center w100p" @click="fHeadSort(item.sortType, 'asc')">
                <span>{{ item.title }}</span>
                <!-- <span class="x-flex" style="flex-direction: column">
                  <i :class="[
                      'el-icon-caret-top',
                      sortType == item.sortType && sortAscDesc == 'asc'
                        ? 'active'
                        : '',
                    ]"></i>
                  <i :class="[
                      'el-icon-caret-bottom',
                      sortType == item.sortType && sortAscDesc == 'desc'
                        ? 'active'
                        : '',
                    ]"></i>
                </span> -->
              </div>
            </template>
          </vxe-column>
        </vxe-table>
        <div class="x-flex" style="position: absolute; bottom: 15px; left: 20px; z-index: 999">
          共 {{ TP }} 页 {{ TR }} 条
          <!-- <span class="x-p-l-20 ">订单金额：{{total.ord_money}}</span> -->
          <span class="x-p-l-10 ">订单金额：{{total.ord_money}}</span>
          <span class="x-p-l-10 ">优惠金额：{{total.dis_money}}</span>
          <span class="x-p-l-10 ">支付金额：{{total.pay_money}}</span>
          <span class="x-p-l-10 ">物流金额：{{total.track_money}}</span>
          <span class="x-p-l-10 ">服务商分润：{{total.partner_ledger_money}}</span>
          <span class="x-p-l-10 ">推荐人分润：{{total.ref_ledger_money}}</span>


        </div>
        <el-pagination background layout="prev, pager, next" :total="Number(TR)" @current-change="fCurrentChange"
          :page-size="50" :current-page="nowPage" style="position: absolute; bottom: 15px; right: 20px; z-index: 999">
        </el-pagination>
      </div>
    </el-card>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        radio: "条件查询",
        merInputVal: "",
        // uploadImgValue:'',//上传的文件名称
        checked: true, //
        nowPage: 1, // 当前页数
        TR: 0, // 总条数
        TP: 0, // 总页数
        tableData: [],
        fileLise: [], //上传文件列表
        sortType: "", // 排序类型
        sortAscDesc: "", // 排序顺序
        state: '',
        order_state: "",
        pay_state: "全部",
        ai_type: 'all',
        cancelDataTime: [],
        pickerOptions: {
          // 选择时间是的快捷方式
          shortcuts: [{
              text: "昨日",
              onClick:(picker)=>  {
                this.frTime = [this.bykApi.timeHelper.manyDaysAgo(1, 3) + ' 00:00:00', this.bykApi.timeHelper
                  .manyDaysAgo(1, 3) +
                  ' 23:59:59'
                ]
                picker.$emit("pick", this.frTime);
              },
            },{
              text: "今日",
              onClick:(picker)=>  {
                this.frTime = [this.bykApi.timeHelper.manyDaysAgo(0, 3) + ' 00:00:00', this.bykApi.timeHelper
                  .manyDaysAgo(0, 3) +
                  ' 23:59:59'
                ]
                picker.$emit("pick", this.frTime);
              },
            },
            {
              text: "本月",
              onClick:(picker)=>  {
                this.frTime = [this.bykApi.timeHelper.getMonthStartDate() + ' 00:00:00', this.bykApi.timeHelper
                  .getMonthEndDate() +
                  ' 23:59:59'
                ]
                picker.$emit("pick", this.frTime);
              },
            },{
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        tableJson: [{
            title: "订单状态",
            width: "100",
            sortType: "ord_state",
          }, {
            title: "支付状态",
            width: "100",
            sortType: "pay_state",
          }, {
            title: "商品名称",
            width: "160",
            sortType: "pro_name",
          },{
            title: "订单金额",
            width: "100",
            sortType: "ord_money",
          }, {
            title: "优惠金额",
            width: "100",
            sortType: "dis_money",
          }, {
            title: "支付金额",
            width: "100",
            sortType: "pay_money",
          },
          {
            title: "支付方式",
            width: "100",
            sortType: "pay_way",
          },{
            title: "订单备注",
            width: "200",
            sortType: "ord_remark",
          }, {
            title: "订单号",
            width: "300",
            sortType: "ord_id",
          },{
            title: "创建时间",
            width: "160",
            sortType: "create_time",
          },
          {
            title: "修改时间",
            width: "160",
            sortType: "chg_time",
          }, {
            title: "商户名称",
            width: "200",
            sortType: "mch_name",
          },
          {
            title: "商户ID",
            width: "140",
            sortType: "mch_id",
          },
          {
            title: "门店ID",
            width: "100",
            sortType: "mall_id",
          },
          {
            title: "服务商",
            width: "160",
            sortType: "partner_name",
          },
          {
            title: "服务商ID",
            width: "120",
            sortType: "partner_id",
          },{
            title: "服务商提成方式",
            width: "120",
            sortType: "partner_ledger_way",
          },{
            title: "服务商提成系数",
            width: "120",
            sortType: "partner_ledger_value",
          },{
            title: "服务商提成金额",
            width: "120",
            sortType: "partner_ledger_money",
          },
{
            title: "推荐人",
            width: "120",
            sortType: "ref_user_name",
          },
{
            title: "推荐人ID",
            width: "120",
            sortType: "ref_user_id",
          },{
            title: "推荐人提成方式",
            width: "120",
            sortType: "ref_ledger_way",
          },{
            title: "推荐人提成系数",
            width: "120",
            sortType: "ref_ledger_value",
          },{
            title: "推荐人提成金额",
            width: "120",
            sortType: "ref_ledger_money",
          },
        ],
        addOrEditAgent: false, // 增加/修改用户
        smShopOrderAddOrEdit: "ADD",
        total:{},

        stateOption: [{
            label: '未绑定'
          },
          {
            label: '已绑定'
          },
          {
            label: '已解绑'
          },
        ]

      };
    },
    watch: {
      pay_state() {
        this.nowPage = 1;
        this.init()
      },
      order_state() {
        this.nowPage = 1;
        this.init()
      },
    },
    created() {
      this.cancelDataTime = [this.bykApi.timeHelper.manyDaysAgo(0, 3) + ' 00:00:00', this.bykApi.timeHelper
        .manyDaysAgo(0, 3) +
        ' 23:59:59'
      ]
      this.init();
    },
    methods: {
      async init() {
        let res = await this.fMchAiManger('GET_LIST');

        if (res.result != "sucess") {
          return this.$message(res.msg);
        }

          this.TR = res.page.TR; //总条数
          this.TP = res.page.TP; //总页数
        this.total = res.total;
        this.tableData = res.data;
      },

      // 解绑
      async unBand(row) {},
      // 排序
      async fHeadSort(type, asc_desc = "") {
        // console.log(this.sortType, type);
        // console.log(type, asc_desc);
        if (this.sortAscDesc == asc_desc) {
          if (this.sortAscDesc == "asc") {
            this.sortAscDesc = "desc";
          } else {
            this.sortAscDesc = "asc";
          }
        } else {
          this.sortAscDesc = asc_desc;
        }
        this.sortType = type;
        this.init();
      },

      fHeadRadioChange(e) {},
      // fHeadSortChange(e) {
      //   this.searchSortVal = e[0];
      // },

      fRegWxUser() {
        this.smShopOrderAddOrEdit = "ADD";
        this.addOrEditAgent = true;
        this.fileLise = []
      },
      // 分页
      async fCurrentChange(e) {
        this.nowPage = e
        let res = await this.fMchAiManger('GET_LIST')

        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },

      async fUpLoadWxFile() {},



      //文件上传
      uploadOnChange(file, fileList) {},
      async fUploadFile(url) {},

      // ------------- 请求 开始 --------------
      async fMchAiManger(oper, ai_id, org_id, mch_id, pos_id, ai_type) {
        let js = {};
        js["OPER"] = "LIST";
        js["MCH_ID"] = '';
        js["MALL_ID"] = '';
        js["ORD_STATE"] = this.order_state; //订单状态  待付款  待发货  已发货  已完成
        js["PAY_STATE"] = this.pay_state; //支付状态  待付款  已付款
        js['START_TIME'] = this.cancelDataTime[0];
        js['OVER_TIME'] = this.cancelDataTime[1];
        js["SEARCH_STR"] = this.merInputVal;
        js["PAGE_SIZE"] = 50;
        js["NOW_PAGE"] = this.nowPage;
        console.log(js)
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi("GET_SHOP_ORDER_DETAIL", js);
        console.log(res)
        return res;
      },



      // ------------- 请求 结束 --------------
    },
  };
</script>

<style lang='less' scoped>
  .smShopOrder {
    .header {
      /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }
    }

    .el-card {
      overflow: auto;
      position: relative;
      width: 100%;
      height: calc(100vh - 120px);
    }

    /deep/ .add-dialog .el-dialog__body {
      padding: 20px 30px 30px !important;
      // height: 600px;
      // overflow-y: scroll;
    }

    .add-dialog {
      .dialog-title {
        line-height: 17px;
        font-size: 14px;
        padding-left: 8px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        &::after {
          content: "";
          display: flex;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 8px;
          border-left: 3px solid #2c6ff2;
        }

        /deep/ .el-button--small {
          font-size: 14px;
          padding: 7px 15px;
        }
      }
    }

    .must {
      &::before {
        content: "*";
        color: #f76062;
        margin-right: 3px;
      }
    }

    .active {
      color: #679aff;
    }

    /deep/ .el-dialog .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog .el-dialog__body {
      padding: 18px;
    }

    //   /deep/ .el-button--default {
    //     border-radius: 0;
    //     border: 0;
    //     background-color: #f0f0f0;
    //     color: #808080;
    //     height: 45px;
    //   }
    /deep/ [class*=" el-icon-"],
    [class^="el-icon-"] {
      line-height: 0.5 !important;
      font-size: 14px;
    }

    /deep/ [class*=" el-icon-"]:hover,
    [class^="el-icon-"]:hover {
      color: #679aff;
      cursor: pointer;
    }

    //
  }

  /* .x-w66{} */
  .must1 {
    position: relative;
  }

  .must1:after {
    position: absolute;
    top: -4px;
    right: 2px;
    content: '*';
    color: red;
    font-size: 120%;
  }
</style>



// WEBPACK FOOTER //
// src/view/smShopOrder.vue